import { COGNITO_MAP, ORG } from '../../util/constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../util/api';

export const authApiSlice = createApi({
    reducerPath: 'authApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        checkCognitoId: builder.mutation({
            query: ({ accessToken, sessionId }) => ({
                url: '/check-cognito-id',
                method: 'POST',
                body: { accessToken, org: ORG, sessionId },
            }),
        }),
        validateAccessToken: builder.query({
            query: () => ({ url: `/validate-access-token?org=${ORG}` })
        }),
    }),
});

export const { 
    useCheckCognitoIdMutation,
    useValidateAccessTokenQuery,
} = authApiSlice;

export const logout = createAsyncThunk(
    'auth/logout',
    async (_, { dispatch }) => {
    try {
        await dispatch(revokeRefreshToken());

        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
        
        const res = await axios.get(COGNITO_MAP["logout_url"])
        if(res.status === 200) {
            window.location.href = res.data;
        }
    } catch (e) {
        console.log("error for logging out is", e)
    }
});

export const loginPhysician = createAsyncThunk(
    'auth/loginPhysician',
    async () => {
        try {
            const url = await axios.get(COGNITO_MAP["auth_url"])
            window.location.href = url.data;
        } catch (e){
            console.error(e);
            console.log("Error logging in. Please try again later.")
        }
    }
);

export const revokeRefreshToken = createAsyncThunk(
    'auth/revokeRefreshToken',
    async () => {
    const refreshToken = localStorage.getItem('refresh_token')
    try {
        await axios.post(COGNITO_MAP["revoke"], {
            refresh_token: refreshToken
        })
    } catch(e) {
        console.log("Error revoking refresh token.")
        console.log(e)
    }
});